import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
// import { ReactSession } from 'react-client-session';
import "bootstrap/dist/css/bootstrap.css";
import "assets/scss/now-ui-dashboard.scss?v=1.5.0";
import "assets/css/demo.css";
import "./App.css";

import AdminLayout from "layouts/Admin.js";
import AuthLayout from "layouts/Auth.js";
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import './utils/versionCheck'; // Initialize version checking

const root = ReactDOM.createRoot(document.getElementById("root"));



root.render(
  <BrowserRouter>
    <Routes>
      <Route path="/admin/*" element={ <AdminLayout /> } />
      <Route path="/auth/*" element={<AuthLayout />} />
      <Route path="*" element={<Navigate to={"/auth/login-page"} replace />} />
    </Routes>
  </BrowserRouter>
);

// Register service worker
serviceWorkerRegistration.register({
  onSuccess: () => {
    console.log('Service Worker registered successfully');
  },
  onUpdate: (registration) => {
    console.log('Service Worker updated');
    // Optionally show a toast or notification to user about the update
  }
});
